export enum DlsTypographyVariants {
    BODY_1 = 'body-1',
    BODY_2 = 'body-2',
    BODY_3 = 'body-3',
    LEGAL_1 = 'legal-1',
    LABEL_1 = 'label-1',
    LABEL_3 = 'label-3',
    HEADING_1 = 'heading-1',
    HEADING_3 = 'heading-3',
    HEADING_4 = 'heading-4'
}
